import Vue from 'vue'
import typeMap from '@/utils/typeMap'

Vue.mixin({
  data () {
    return {
      types: typeMap
    }
  },
  methods: {
    shakeElement (element) {
      element.classList.add('shake-animation')
      setTimeout(() => {
        element.classList.remove('shake-animation')
      }, 1000)
    },
    getIconByName (name) {
      let type = this.types.find((type) => type.name === name)
      return type.icon
    },
    now () {
      let date = new Date()
      let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      let timeString = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
      return `${dateString} ${timeString}`
    }
  },
  computed: {
    status () {
      return this.$store.state.syncStatus
    }
  }
})
